'use strict';

import { IMeta } from '@ispm/core/interfaces/meta.interface';
import { IResourceReference } from '@ispm/core/interfaces/resource-reference.interface';
import { Observable } from 'rxjs';

export interface IBulkOperationConfigInterface {
  label: string;
  pollingInterval: number;
  operations: Array<IBulkOperationItem>;
}

export interface IBulkOperationItem {
  type: string;
  label: string;
  maxItems: number;
  URL: string;
  additionalParameters?: { };
}

export interface IBulkOperationDropdownItem {
  label: string;
  command: any;
}

export interface IBulkOperationPollingItem {
  id: string;
  meta: IMeta;
  status: IBulkOperationStatus;
  authorization: IResourceReference;
  context: Array<IResourceReference>;
}

export interface IBulkOperationStatus {
  value: string;
  text: string;
  display: IMeta;
}

export interface IBulkOperationExecuter {
  beforeExecute: (operationConfig: IBulkOperationItem, selectedTests, exceededTestsAmount, maxItemsCount: number) => Observable<any>;
}

export enum BULK_OPERATION_COMMAND {
  REASSIGN = 'REASSIGN',
}

export enum BULK_OPERATION_STATUS {
  BULK_SUCCESS = 'SUCCEEDED',
  BULK_PARTLY_SUCCESS = 'PARTLY',
  BULK_FAILED = 'FAILED'
}
